export class IntervenantEngagement {
    static jsonMap = {
        id: { key: 'id', optional: true },
        nom: { key: 'nom', optional: true, default: '' },
        prenom: { key: 'prenom', optional: true, default: '' }
    };

    public id: number = undefined;
    public nom: string = undefined;
    public prenom: string = undefined;
}
